import { ref, computed } from "vue";
import { defineStore } from "pinia";
export const useUserTokenStore = defineStore("userTokenStore", () => {
    const user_credentials = ref({
        user_id: 0,
        refresh_token: "",
        token: "",
        fp: "",
    });
    function setCredentials(input) {
        user_credentials.value = input;
    }
    function isLogined() {
        if (user_credentials.value.token === "") {
            return false;
        }
        else {
            return true;
        }
    }
    function logout() {
        user_credentials.value = {
            user_id: 0,
            refresh_token: "",
            token: "",
        };
    }
    return {
        user_credentials,
        setCredentials,
        isLogined,
        logout,
    };
}, { persist: true });
